'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cx } from '../../../internal/cx.js';
import { useFieldControl } from '../form-field/index.js';
export const Input = forwardRef(function Input({ size = 'md', invalid, className, ...rest }, ref) {
    const props = useFieldControl(rest, { invalid });
    return _jsx("input", { ref: ref, ...props, "data-size": size, className: cx('mn-input', className) });
});
export const Textarea = forwardRef(function Textarea({ invalid, resizable = true, rows = 3, className, ...rest }, ref) {
    const props = useFieldControl(rest, { invalid });
    return (_jsx("textarea", { ref: ref, rows: rows, ...props, "data-resizable": resizable || undefined, className: cx('mn-input', 'mn-textarea', className) }));
});
//# sourceMappingURL=text-field.js.map